import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Translation from '../../../../common/translation/translation.component';
import { HistoryLayout } from '../../../../common/history/history-layout.component';
import InvoiceHistory from './invoice-history';
import { invoiceHistoryActions } from "../../../../../store/external/invoice/invoice/invoice-history.reducer";

class InvoiceHistoryComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isColSearchShow: false
        }
    }

    setColSearch = (value) => {
        this.setState({isColSearchShow: value})
    }

    onClickExtract = () => {
        const { invoiceDetailsId, extractInvoiceHistoryLogs } = this.props;
        if (window.confirm(this.state.extractAlertMsg)) {
            extractInvoiceHistoryLogs(invoiceDetailsId);
        }
    }

    onChangeExtractAlertMsg = (val, key) => {
        this.setState({
            extractAlertMsg: val
        });
    }

    render() {
        return (
            <>
            <Translation
                    getOnlyText={true}
                    onChangeTranslation={this.onChangeExtractAlertMsg}
                    translationKey={"export_alert_message"} />

                <HistoryLayout 
                    listHistoryTab={this.props.listHistoryTab}
                    selectedIndex={[]}
                    extractAction={this.onClickExtract}
                    displaySearchBox={this.setColSearch}
                    isReadOnly={false}
                    isReadAndExtractOnly={false}
                    isReadAndWrite={true}
                    hideCustomColumn={true}
                    {...this.props.roles }
                >
                    
                   <InvoiceHistory invoiceDetailsId={this.props.invoiceDetailsId} isColSearchShow={this.state.isColSearchShow} />
                </HistoryLayout>     
            </>
        );
    }
}

export default connect(
    state => {
        const { invoiceHistory } = state;

        return {
            invoiceHistory
        };
    },
    dispatch => bindActionCreators(
        Object.assign({}, invoiceHistoryActions),
        dispatch
    )
)(InvoiceHistoryComponent);